import { render } from "./GoCaptcha.vue?vue&type=template&id=0a7e9218"
import script from "./GoCaptcha.vue?vue&type=script&lang=js"
export * from "./GoCaptcha.vue?vue&type=script&lang=js"

import "./GoCaptcha.vue?vue&type=style&index=0&id=0a7e9218&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__